import React from 'react'
import ArticleCard from './cards/article'
import usePostsQuery from '../hooks/use-posts-query' 

const AgentPosts = (props) => {

  let { title, agents } = props

  const data = usePostsQuery()

  const slider = React.useRef()
  const [items, setItems] = React.useState([true])

  let initial = 0

  const _showComponent = (key) => {
    let nextitems = [];
    nextitems[key] = true
    setItems(nextitems)
  }

  const sliderLink = (event) => {
    if (initial > 10) event.preventDefault();
  }

  React.useEffect(() => {

    let isDown = false;
    let startX;
    let scrollLeft;
    initial = 0;

    if (slider.current) {

      slider.current.addEventListener('mousedown', (event) => {
        isDown = true;
        startX = event.pageX - slider.current.offsetLeft;
        scrollLeft = slider.current.scrollLeft;
        initial = 0;
      });
      slider.current.addEventListener('mouseleave', (event) => {
        isDown = false;
      });
      slider.current.addEventListener('mouseup', (event) => {
        isDown = false;
      });
      slider.current.addEventListener('mousemove', (event) => {
        if (!isDown) return;
        event.preventDefault();
        const x = event.pageX - this.slider.current.offsetLeft;
        const walk = (x - startX) * 2; //scroll-fast
        initial += Math.abs(walk);
        slider.current.scrollLeft = scrollLeft - walk;
      });
    }
  }, [])

  let removeListItem = false

  let posts = []

  if (data?.posts?.nodes.length > 0) {
    if (agents) {
      posts = data?.posts.nodes.filter(el => {
        let agentsArray = el.acf?.author?.map(agent => agent.id)
        if (!agentsArray) {
          return false
        }
        return agents.some(agent => agentsArray.includes(agent.id));
      })
    }
  }

  return (
    <section className='testimonials-block'>
      <div className='testimonials-block__inner'>
        <div className='testimonials-block__content'>

          <div className='testimonials-block__menu'>
            <ul>
              {posts?.length > 0 && !removeListItem &&
                <li className={items[1] ? `active` : ''} onClick={() => _showComponent(0)}><span>{title}</span></li>
              }
            </ul>
          </div>

          {posts?.length > 0 &&
            <div className={`testimonials-block__testimonials ${items[0] ? 'active' : ''}`}>
              <div className='profile__list'>
                <div className='profile__slider' ref={slider}>
                  {posts?.slice(0, 4).map((el, i) => (
                    <ArticleCard {...el} key={i} onClick={sliderLink} />
                  ))}
                </div>
              </div>
            </div>
          }

        </div>
      </div>
    </section>
  )
}

export default AgentPosts
